enum ClaimTypes{
    Vehicle = 2,
    Glass = 1
  }
  
  export default ClaimTypes
  